import { render, staticRenderFns } from "./docRegisAssetPagination.vue?vue&type=template&id=0c50c80e&scoped=true&"
import script from "./docRegisAssetPagination.vue?vue&type=script&lang=js&"
export * from "./docRegisAssetPagination.vue?vue&type=script&lang=js&"
import style0 from "./docRegisAssetPagination.vue?vue&type=style&index=0&id=0c50c80e&prod&scoped=true&lang=css&"
import style1 from "./docRegisAssetPagination.vue?vue&type=style&index=1&id=0c50c80e&prod&lang=scss&scoped=true&"
import style2 from "./docRegisAssetPagination.vue?vue&type=style&index=2&id=0c50c80e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c50c80e",
  null
  
)

export default component.exports